export const it = {
  "Rubrics": "Griglie di valutazione",
  "New Rubric": "Nuova griglia",
  "Create scoring rubrics for any topic, subject, or assignment": "Crea griglie di valutazione per qualsiasi argomento, materia o compito",
  "AI Draft": "Bozza con IA",
  "Start Blank": "Inizia da zero",
  "Topic / what to assess": "Argomento / cosa valutare",
  "Class (optional)": "Classe (facoltativo)",
  "Title (optional)": "Titolo (facoltativo)",
  "Levels": "Livelli",
  "Generate Rubric": "Genera griglia",
  "Create": "Crea",
  "Criteria": "Criteri",
  "Criterion name": "Nome del criterio",
  "Descriptor...": "Descrittore...",
  "Add Criterion": "Aggiungi criterio",
  "Add level": "Aggiungi livello",
  "Remove level": "Rimuovi livello",
  "Remove": "Rimuovi",
  "Score Student": "Valuta studente",
  "Save to Gradebook": "Salva nel registro",
  "Tap cells below to score": "Tocca le celle per valutare",
  "Select student": "Seleziona studente",
  "Select a rubric or create a new one": "Seleziona una griglia o creane una nuova",
  "No rubrics yet. Create your first one!": "Ancora nessuna griglia. Crea la prima!",
  "Rubric created!": "Griglia creata!",
  "Rubric saved": "Griglia salvata",
  "Rubric deleted": "Griglia eliminata",
  "Rubric duplicated": "Griglia duplicata",
  "Delete this rubric?": "Eliminare questa griglia?",
  "Duplicate": "Duplica",
  "No class": "Nessuna classe",
  "Rubric": "Griglia",
  "Saved to gradebook": "Salvato nel registro",
  "Failed to save score": "Salvataggio del voto non riuscito",
  "Select a class and student": "Seleziona una classe e uno studente",
  "Failed to create rubric. Please try again.": "Creazione non riuscita. Riprova.",
  "Analyzing the topic...": "Analisi dell'argomento...",
  "Defining criteria...": "Definizione dei criteri...",
  "Writing level descriptors...": "Scrittura dei descrittori...",
  "Excellent": "Eccellente",
  "Good": "Buono",
  "Fair": "Sufficiente",
  "Needs Improvement": "Da migliorare",
  "New Level": "Nuovo livello",
  "Total points possible": "Punti totali possibili",
  "Loading...": "Caricamento...",
  "Failed to duplicate": "Duplicazione non riuscita",
  "Send to Google Classroom": "Invia a Google Classroom",
  "Opening Google Classroom...": "Apertura di Google Classroom...",
  "Failed to share to Classroom": "Condivisione su Classroom non riuscita",
  "Analyzing standards...": "Analisi degli standard...",
  "Writing content...": "Scrittura del contenuto...",
  "Formatting sections...": "Formattazione delle sezioni...",
  "Finalizing...": "Finalizzazione...",
  "All Plans": "Tutti i piani",
  "Color": "Colore",
  "Current": "Attuale",
  "Delete": "Elimina",
  "Delete this folder? Plans will be moved to \"Unfiled\"": "Eliminare questa cartella? I piani verranno spostati in \"Senza cartella\"",
  "Edit": "Modifica",
  "Edit Folder": "Modifica cartella",
  "Error creating folder": "Errore nella creazione della cartella",
  "Error deleting folder": "Errore nell'eliminazione della cartella",
  "Error moving plan": "Errore nello spostamento del piano",
  "Error updating folder": "Errore nell'aggiornamento della cartella",
  "Ex: Math 5th Grade": "Es: Matematica 5ª Elementare",
  "Folder created": "Cartella creata",
  "Folder deleted": "Cartella eliminata",
  "Folder name": "Nome della cartella",
  "Folder updated": "Cartella aggiornata",
  "Folders": "Cartelle",
  "Move to folder": "Sposta nella cartella",
  "New Folder": "Nuova cartella",
  "No objective defined": "Nessun obiettivo definito",
  "No unfiled plans": "Nessun piano senza cartella",
  "Plan moved": "Piano spostato",
  "This folder is empty": "Questa cartella è vuota",
  "Unfiled": "Senza cartella",
  "You don't have any lesson plans": "Non hai piani di lezione",
  "Your lesson plans": "I tuoi piani di lezione",
  "Take Attendance": "Fare l'appello",
  "You have": "Hai",
  "class(es) without attendance today": "classe/i senza appello oggi",
  "Student Intervention Needed": "Intervento necessario sugli studenti",
  "student(s) showing significant struggles - consider reaching out": "studente/i con difficoltà significative - considera di contattarli",
  "Overdue Grading": "Correzioni in ritardo",
  "assignment(s) past due date need grading": "compito/i scaduti da correggere",
  "Plan Next Week": "Pianifica la prossima settimana",
  "class(es) don't have lessons planned for next week": "classe/i senza lezioni pianificate per la prossima settimana",
  "10th Grade": "2ª Superiore (10º)",
  "11th Grade": "3ª Superiore (11º)",
  "12th Grade": "4ª Superiore (12º)",
  "1st Grade": "1ª Elementare",
  "2nd Grade": "2ª Elementare",
  "3rd Grade": "3ª Elementare",
  "4th Grade": "4ª Elementare",
  "5th Grade": "5ª Elementare",
  "6th Grade": "1ª Media (6º)",
  "7th Grade": "2ª Media (7º)",
  "8th Grade": "3ª Media (8º)",
  "9th Grade": "1ª Superiore (9º)",
  "AI Assignment generated": "Compito IA generato",
  "AI Assignments": "Compiti IA",
  "AI Assistant": "Assistente IA",
  "AI Generated": "Generato dall'IA",
  "AI Grading": "Correzione IA",
  "AI Recommendations": "Raccomandazioni IA",
  "AI Suggestions": "Suggerimenti IA",
  "AI Teaching Assistant": "Assistente didattico IA",
  "Access Link": "Link di accesso",
  "Access resources to help plan your lessons": "Accedi alle risorse per pianificare le tue lezioni",
  "Activity Ideas": "Idee per attività",
  "Adapt": "Adattare",
  "Adapt with AI": "Adatta con l'IA",
  "Adaptive Learning": "Apprendimento adattivo",
  "Add": "Aggiungi",
  "Add New Category": "Aggiungi nuova categoria",
  "Add Question": "Aggiungi domanda",
  "Add option": "Aggiungi opzione",
  "Add pair": "Aggiungi coppia",
  "Add to Calendar": "Aggiungi al calendario",
  "Additional Instructions (optional)": "Istruzioni aggiuntive (facoltativo)",
  "Additional Notes": "Note aggiuntive",
  "Additional instructions": "Istruzioni aggiuntive",
  "Additional notes...": "Note aggiuntive...",
  "All caught up!": "Tutto in regola!",
  "All semesters": "Tutti i semestri",
  "All students on track!": "Tutti gli studenti in carreggiata!",
  "All suggestions applied": "Tutti i suggerimenti applicati",
  "Analysis took too long. Please try again.": "L'analisi ha impiegato troppo tempo. Riprova.",
  "Analyzing PDF with AI... This may take up to a minute.": "Analisi del PDF con l'IA... Potrebbe richiedere fino a un minuto.",
  "Analyzing...": "Analisi in corso...",
  "Answer Key": "Soluzioni",
  "Answer:": "Risposta:",
  "Apply All": "Applica tutto",
  "Apply as-is": "Applica così com'è",
  "Apply to notes": "Applica alle note",
  "Approve & Publish": "Approva e pubblica",
  "Art": "Arte",
  "Ask me about planning, standards, teaching strategies...": "Chiedimi di pianificazione, standard, strategie didattiche...",
  "Assessment": "Valutazione",
  "Assignment List": "Elenco compiti",
  "Assignment created": "Compito creato",
  "Assignment created!": "Compito creato!",
  "Assignment created. Student link copied to clipboard.": "Compito creato. Link studente copiato negli appunti.",
  "Assignment deleted": "Compito eliminato",
  "Assignment name": "Nome del compito",
  "Assignment updated": "Compito aggiornato",
  "Assignments & Gradebook": "Compiti e registro voti",
  "Assignments to Grade": "Compiti da correggere",
  "At Risk": "A rischio",
  "Attendance": "Presenze",
  "Attendance Rpt": "Rapporto presenze",
  "Attendance saved": "Presenze salvate",
  "Automate your entire Sunday night prep with a single prompt": "Automatizza tutta la preparazione della domenica sera con un solo comando",
  "Back": "Indietro",
  "Based on grades & attendance": "In base a voti e presenze",
  "Bilingual": "Bilingue",
  "Both (CC + PR)": "Entrambi (CC + PR)",
  "Briefly describe what makes this lesson structure successful...": "Descrivi brevemente cosa rende efficace questa struttura di lezione...",
  "Build Questions": "Crea domande",
  "CC + PR": "CC + PR",
  "Calendar": "Calendario",
  "Calendar Events": "Eventi del calendario",
  "Cancel": "Annulla",
  "Cannot delete category with assignments": "Impossibile eliminare una categoria con compiti",
  "Categories": "Categorie",
  "Category": "Categoria",
  "Category created": "Categoria creata",
  "Category deleted": "Categoria eliminata",
  "Category updated": "Categoria aggiornata",
  "Chat": "Chat",
  "Chat with AI Assistant": "Chatta con l'assistente IA",
  "Choose File": "Scegli file",
  "Class": "Classe",
  "Class created": "Classe creata",
  "Class deleted": "Classe eliminata",
  "Class updated": "Classe aggiornata",
  "Classes Today": "Lezioni di oggi",
  "Close": "Chiudi",
  "Closure": "Conclusione",
  "Column A": "Colonna A",
  "Column B": "Colonna B",
  "Complete required fields": "Compila i campi obbligatori",
  "Connecting to server... Retrying": "Connessione al server... Nuovo tentativo",
  "Content generated! Use the Save button to save it.": "Contenuto generato! Usa il pulsante Salva per salvarlo.",
  "Convert to Online Test": "Converti in test online",
  "Copied!": "Copiato!",
  "Copy": "Copia",
  "Copy Link": "Copia link",
  "Copy link": "Copia link",
  "Copy student link": "Copia link studente",
  "Core": "Materie principali",
  "Correct answer": "Risposta corretta",
  "Create assessments with answers": "Crea valutazioni con soluzioni",
  "Create with AI": "Crea con l'IA",
  "Created with TeacherHubPro - AI Assistant for Teachers": "Creato con TeacherHubPro - Assistente IA per insegnanti",
  "Creative classroom activities": "Attività creative per la classe",
  "Current Categories": "Categorie attuali",
  "Customized template applied!": "Modello personalizzato applicato!",
  "Dark": "Scuro",
  "Dark mode": "Modalità scura",
  "Date Range (2 Weeks)": "Periodo (2 settimane)",
  "Date of Test/Quiz": "Data del test/quiz",
  "Day theme...": "Tema del giorno...",
  "Delete this assignment?": "Eliminare questo compito?",
  "Delete this prep batch?": "Eliminare questa preparazione?",
  "Delete this template?": "Eliminare questo modello?",
  "Deleted": "Eliminato",
  "Describe the learning goal...": "Descrivi l'obiettivo di apprendimento...",
  "Describe what you need to prep and the agent will generate everything automatically": "Descrivi cosa devi preparare e l'agente genererà tutto automaticamente",
  "Describe your lesson and AI will generate a standards-based plan.": "Descrivi la tua lezione e l'IA genererà un piano basato sugli standard.",
  "Description": "Descrizione",
  "Description / Instructions": "Descrizione / Istruzioni",
  "Differentiation strategies": "Strategie di differenziazione",
  "Difficulty": "Difficoltà",
  "Done": "Fatto",
  "Due Date (optional)": "Data di consegna (facoltativo)",
  "Due:": "Consegna:",
  "Duration (minutes)": "Durata (minuti)",
  "E.g., Decimal multiplication": "Es.: Moltiplicazione dei decimali",
  "E.g., Equivalent fractions": "Es.: Frazioni equivalenti",
  "E.g., Focus on word problems...": "Es.: Focus sui problemi scritti...",
  "E.g., Fractions Plan - 4th Grade": "Es.: Piano Frazioni - 4ª Elementare",
  "E.g., Fractions with different denominators": "Es.: Frazioni con denominatori diversi",
  "E.g., Fractions, American Revolution...": "Es.: Frazioni, Rivoluzione americana...",
  "E.g., math, fractions, hands-on": "Es.: matematica, frazioni, pratico",
  "ELA": "Italiano/Lettere",
  "Easy": "Facile",
  "Edit Assignment": "Modifica compito",
  "Edit Class": "Modifica classe",
  "Edit Parent Email": "Modifica e-mail ai genitori",
  "Edit class": "Modifica classe",
  "Educational Games": "Giochi educativi",
  "End": "Fine",
  "English": "Inglese",
  "English/Reading": "Inglese/Lettura",
  "Enjoy your day off": "Goditi il tuo giorno libero",
  "Enrichment": "Approfondimento",
  "Enter a topic": "Inserisci un argomento",
  "Enter question...": "Inserisci la domanda...",
  "Enter your prep request": "Inserisci la tua richiesta di preparazione",
  "Error applying template": "Errore nell'applicare il modello",
  "Error creating class": "Errore nella creazione della classe",
  "Error customizing": "Errore di personalizzazione",
  "Error deleting": "Errore di eliminazione",
  "Error exporting calendar": "Errore nell'esportazione del calendario",
  "Error generating link": "Errore nella generazione del link",
  "Error generating plan": "Errore nella generazione del piano",
  "Error generating suggestions": "Errore nella generazione dei suggerimenti",
  "Error generating weekly plan": "Errore nella generazione del piano settimanale",
  "Error loading AI assignments": "Errore nel caricamento dei compiti IA",
  "Error loading template": "Errore nel caricamento del modello",
  "Error loading templates": "Errore nel caricamento dei modelli",
  "Error saving template": "Errore nel salvataggio del modello",
  "Error sending email": "Errore nell'invio dell'e-mail",
  "Essay": "Tema",
  "Essay answers are graded manually": "I temi vengono corretti manualmente",
  "Everything published successfully!": "Tutto pubblicato con successo!",
  "Ex: Chapter 1 - Vocabulary": "Es: Capitolo 1 - Vocabolario",
  "Ex: English": "Es: Inglese",
  "Ex: Greetings and Introductions": "Es: Saluti e presentazioni",
  "Ex: Prep next week for Unit 3 History (Civil War), matching state curriculum standards": "Es: Preparare la prossima settimana per l'Unità 3 di Storia (Guerra Civile), secondo gli standard curricolari",
  "Ex: Unit 1": "Es: Unità 1",
  "Expiration (days)": "Scadenza (giorni)",
  "Expires:": "Scade:",
  "Failed to delete": "Eliminazione non riuscita",
  "Failed to generate assignment": "Generazione del compito non riuscita",
  "Failed to generate content. Please try again.": "Generazione del contenuto non riuscita. Riprova.",
  "Failed to load data": "Caricamento dei dati non riuscito",
  "Failed to parse PDF": "Analisi del PDF non riuscita",
  "Failed to publish": "Pubblicazione non riuscita",
  "Failed to save": "Salvataggio non riuscito",
  "Failed to start agent": "Avvio dell'agente non riuscito",
  "Failed to upload file": "Caricamento del file non riuscito",
  "False": "Falso",
  "File uploaded": "File caricato",
  "Fill Blank": "Completa gli spazi",
  "First and last name required": "Nome e cognome obbligatori",
  "Friday Quiz": "Quiz del venerdì",
  "From": "Dal",
  "Full weekly plan generated! Review each day.": "Piano settimanale completo generato! Controlla ogni giorno.",
  "Generate": "Genera",
  "Generate Assignment": "Genera compito",
  "Generate Assignment with AI": "Genera compito con l'IA",
  "Generate Content": "Genera contenuto",
  "Generate Full Week": "Genera settimana completa",
  "Generate Plan": "Genera piano",
  "Generate Plan with AI": "Genera piano con l'IA",
  "Generate a structured weekly lesson plan with objectives, daily activities, and materials.": "Genera un piano di lezioni settimanale strutturato con obiettivi, attività giornaliere e materiali.",
  "Generate a weekly plan with AI and save it as a template": "Genera un piano settimanale con l'IA e salvalo come modello",
  "Generate complete lesson plans": "Genera piani di lezione completi",
  "Generate content and use the \"Save Content\" button to save it here": "Genera contenuti e usa il pulsante \"Salva contenuto\" per salvarli qui",
  "Generate materials based on National Standards, instantly.": "Genera istantaneamente materiali basati sugli standard nazionali.",
  "Generate practice worksheets": "Genera schede di esercizi",
  "Generate with AI": "Genera con l'IA",
  "Generated Content": "Contenuto generato",
  "Generated Questions": "Domande generate",
  "Generated content will appear here": "Il contenuto generato apparirà qui",
  "Generated with AI Assistant": "Generato con l'assistente IA",
  "Generating content...": "Generazione del contenuto...",
  "Generating link...": "Generazione del link...",
  "Generating week...": "Generazione della settimana...",
  "Generating...": "Generazione...",
  "Generation failed.": "Generazione non riuscita.",
  "Generation failed. Please try again.": "Generazione non riuscita. Riprova.",
  "Generation timed out": "Tempo di generazione scaduto",
  "Generation took too long. Please try again.": "La generazione ha impiegato troppo tempo. Riprova.",
  "Geography": "Geografia",
  "Get detailed topic summaries": "Ottieni riassunti dettagliati degli argomenti",
  "Go to SM Aprendizaje": "Vai a SM Aprendizaje",
  "Grade": "Classe",
  "Grade Level": "Livello scolastico",
  "Grade Level *": "Livello scolastico *",
  "Grade Report": "Pagella",
  "Grade Scale": "Scala di valutazione",
  "Gradebook": "Registro voti",
  "Grades": "Voti",
  "Hard": "Difficile",
  "Health": "Salute",
  "Hi! I'm your AI assistant.": "Ciao! Sono il tuo assistente IA.",
  "High": "Alto",
  "History": "Storia",
  "Hook/Intro": "Aggancio/Introduzione",
  "How do I teach fractions?": "Come insegno le frazioni?",
  "How to capture attention...": "Come catturare l'attenzione...",
  "How to close the lesson...": "Come concludere la lezione...",
  "I can help you with lesson planning, teaching strategies, and questions about standards.": "Posso aiutarti con la pianificazione delle lezioni, le strategie didattiche e le domande sugli standard.",
  "Ideas for reading activities": "Idee per attività di lettura",
  "Instructions for students...": "Istruzioni per gli studenti...",
  "Instructions for this question (optional)...": "Istruzioni per questa domanda (facoltativo)...",
  "Instructions:": "Istruzioni:",
  "Integration with other subjects": "Integrazione con altre materie",
  "Item": "Elemento",
  "Kindergarten": "Scuola dell'infanzia",
  "Language": "Lingua",
  "Learning Goal": "Obiettivo di apprendimento",
  "Learning Objective/s": "Obiettivo/i di apprendimento",
  "Lesson Date Range": "Periodo della lezione",
  "Lesson Plan": "Piano di lezione",
  "Lesson Templates": "Modelli di lezione",
  "Lesson Topic": "Argomento della lezione",
  "Lessons": "Lezioni",
  "Light": "Chiaro",
  "Light mode": "Modalità chiara",
  "Link copied": "Link copiato",
  "Link copied to clipboard": "Link copiato negli appunti",
  "Link copied!": "Link copiato!",
  "List of materials...": "Elenco dei materiali...",
  "Loading templates...": "Caricamento dei modelli...",
  "Low": "Basso",
  "Manage Grade Categories": "Gestisci categorie di voti",
  "Manage your classes and students": "Gestisci le tue classi e i tuoi studenti",
  "Manual Assignments": "Compiti manuali",
  "Match": "Abbinamento",
  "Match:": "Abbina:",
  "Matching": "Abbinamento",
  "Materials Needed": "Materiali necessari",
  "Math": "Matematica",
  "Mathematics": "Matematica",
  "Medium": "Medio",
  "Multiple Choice": "Scelta multipla",
  "Music": "Musica",
  "My Prep Batches": "Le mie preparazioni",
  "My Templates": "I miei modelli",
  "Name (English)": "Nome (inglese)",
  "Name (Spanish)": "Nome (spagnolo)",
  "Name is required": "Il nome è obbligatorio",
  "New Lesson": "Nuova lezione",
  "New Weekly Prep": "Nuova preparazione settimanale",
  "New chat": "Nuova chat",
  "No assignments": "Nessun compito",
  "No assignments created": "Nessun compito creato",
  "No categories. Create one to get started.": "Nessuna categoria. Creane una per iniziare.",
  "No classes today": "Nessuna lezione oggi",
  "No classes yet": "Ancora nessuna classe",
  "No content to save": "Nessun contenuto da salvare",
  "No email generated": "Nessuna e-mail generata",
  "No pending assignments": "Nessun compito in sospeso",
  "No prep batches yet": "Ancora nessuna preparazione",
  "No questions found in the PDF": "Nessuna domanda trovata nel PDF",
  "No questions to print": "Nessuna domanda da stampare",
  "No quiz generated": "Nessun quiz generato",
  "No risk alerts at this time": "Nessun avviso di rischio al momento",
  "No saved plans yet": "Ancora nessun piano salvato",
  "No saved templates": "Nessun modello salvato",
  "No students": "Nessuno studente",
  "No students in this class": "Nessuno studente in questa classe",
  "No students yet": "Ancora nessuno studente",
  "No suggestions to save": "Nessun suggerimento da salvare",
  "Number of Questions": "Numero di domande",
  "Number of questions": "Numero di domande",
  "Open Portal": "Apri portale",
  "Option": "Opzione",
  "Optional: add specific details...": "Facoltativo: aggiungi dettagli specifici...",
  "Or adapt for your specific topic:": "Oppure adatta al tuo argomento specifico:",
  "Or create a new prep batch above": "Oppure crea una nuova preparazione qui sopra",
  "Or customize for new topic:": "Oppure personalizza per un nuovo argomento:",
  "Original topic:": "Argomento originale:",
  "Other": "Altro",
  "Overdue": "In ritardo",
  "Parent Email": "E-mail ai genitori",
  "Parent Portal": "Portale genitori",
  "Period": "Ora",
  "Physical Education": "Educazione fisica",
  "Plan Title": "Titolo del piano",
  "Plan Type": "Tipo di piano",
  "Plan created": "Piano creato",
  "Plan deleted": "Piano eliminato",
  "Plan duplicated": "Piano duplicato",
  "Plan generated! Review and edit as needed.": "Piano generato! Controlla e modifica se necessario.",
  "Plan saved!": "Piano salvato!",
  "Plan updated": "Piano aggiornato",
  "Play to Learn": "Gioca per imparare",
  "Please add an objective or topic first to generate suggestions": "Aggiungi prima un obiettivo o un argomento per generare suggerimenti",
  "Please add an objective or topic first to generate the weekly plan": "Aggiungi prima un obiettivo o un argomento per generare il piano settimanale",
  "Please allow pop-ups to print": "Consenti i pop-up per stampare",
  "Please enter a new topic": "Inserisci un nuovo argomento",
  "Please fill in all fields": "Compila tutti i campi",
  "Please fill in all required fields": "Compila tutti i campi obbligatori",
  "Please respond in English.": "Please respond in Italian.",
  "Prep Agent": "Agente di preparazione",
  "Prep agent started": "Agente di preparazione avviato",
  "Prep failed": "Preparazione non riuscita",
  "Presentations": "Presentazioni",
  "Pricing": "Prezzi",
  "Print": "Stampa",
  "Print / PDF": "Stampa / PDF",
  "Print / Save PDF": "Stampa / Salva PDF",
  "Published": "Pubblicato",
  "Question Types": "Tipi di domande",
  "Quick Actions": "Azioni rapide",
  "Quiz/Assessment": "Quiz/Valutazione",
  "Quiz/Test": "Quiz/Test",
  "Ready for review": "Pronto per la revisione",
  "Regenerate": "Rigenera",
  "Report Cards": "Pagelle",
  "Save": "Salva",
  "Save & Get Student Link": "Salva e ottieni il link studente",
  "Save Changes": "Salva modifiche",
  "Save Content": "Salva contenuto",
  "Save Template": "Salva modello",
  "Save as Template": "Salva come modello",
  "Save this plan to reuse with different topics": "Salva questo piano per riutilizzarlo con altri argomenti",
  "Saved": "Salvato",
  "Saved Lesson Plans": "Piani di lezione salvati",
  "Saved Content": "Contenuti salvati",
  "ESL Support": "Supporto ESL",
  "Rubric adapted for English learners (WIDA + PR standards)": "Rubrica adattata per studenti di inglese (standard WIDA + PR)",
  "Generate ESL-level material for English learners (WIDA + PR standards)": "Genera materiale a livello ESL per studenti di inglese (standard WIDA + PR)",
  "Saved on": "Salvato il",
  "Schedule will appear in your Command Center": "L'orario apparirà nel tuo centro di comando",
  "Science": "Scienze",
  "Select Tool": "Seleziona strumento",
  "Select a category": "Seleziona una categoria",
  "Select a class": "Seleziona una classe",
  "Select a class to view its students": "Seleziona una classe per vedere i suoi studenti",
  "Select a prep batch to view details": "Seleziona una preparazione per vedere i dettagli",
  "Select class": "Seleziona classe",
  "Select...": "Seleziona...",
  "Semester": "Semestre",
  "Send Email": "Invia e-mail",
  "Send via Email": "Invia per e-mail",
  "Sending...": "Invio in corso...",
  "Share this link with the student's parents. The portal is read-only.": "Condividi questo link con i genitori dello studente. Il portale è di sola lettura.",
  "Short Answer": "Risposta breve",
  "Skill...": "Competenza...",
  "Slides": "Diapositive",
  "Social Studies": "Studi sociali",
  "Spanish": "Spagnolo",
  "Specify other activity...": "Specifica un'altra attività...",
  "Specify other material...": "Specifica altro materiale...",
  "Standards": "Standard",
  "Standards Framework": "Quadro degli standard",
  "Start": "Inizio",
  "Start Prep Agent": "Avvia agente di preparazione",
  "Starter": "Base",
  "Starter Templates": "Modelli di base",
  "Story title": "Titolo della storia",
  "Student": "Studente",
  "Student PDF": "PDF studente",
  "Student Progress": "Progresso degli studenti",
  "Student added": "Studente aggiunto",
  "Student deleted": "Studente eliminato",
  "Student updated": "Studente aggiornato",
  "Students at Risk": "Studenti a rischio",
  "Sub Packet": "Pacchetto per supplente",
  "Subject": "Materia",
  "Subject *": "Materia *",
  "Suggest activities": "Suggerisci attività",
  "Suggestions applied to notes": "Suggerimenti applicati alle note",
  "Tags (comma separated)": "Tag (separati da virgola)",
  "Take": "Svolgi",
  "Taxonomy Levels (Webb 2005)": "Livelli tassonomici (Webb 2005)",
  "Teacher": "Insegnante",
  "Teacher Name": "Nome dell'insegnante",
  "Teacher name": "Nome dell'insegnante",
  "Technology": "Tecnologia",
  "Template deleted": "Modello eliminato",
  "Template name *": "Nome del modello *",
  "Template saved!": "Modello salvato!",
  "Templates": "Modelli",
  "This will delete the class and all its students.": "Questo eliminerà la classe e tutti i suoi studenti.",
  "To": "Al",
  "To Grade": "Da correggere",
  "Today's Schedule": "Orario di oggi",
  "Tools": "Strumenti",
  "Topic": "Argomento",
  "Topic *": "Argomento *",
  "Topic Summary": "Riassunto dell'argomento",
  "Topic:": "Argomento:",
  "Total Weight": "Peso totale",
  "Tour": "Tour",
  "True": "Vero",
  "True/False": "Vero/Falso",
  "Type your question...": "Scrivi la tua domanda...",
  "Upcoming Lessons": "Prossime lezioni",
  "Update Assignment": "Aggiorna compito",
  "Upload File": "Carica file",
  "Upload a test or document": "Carica un test o un documento",
  "Uploading...": "Caricamento...",
  "Use proven templates or save your own successful plans": "Usa modelli collaudati o salva i tuoi piani di successo",
  "Use this template": "Usa questo modello",
  "View": "Visualizza",
  "View All": "Vedi tutto",
  "View Assignments": "Vedi compiti",
  "View starter templates": "Vedi modelli di base",
  "Week 1": "Settimana 1",
  "Week 1 - From": "Settimana 1 - Dal",
  "Week 1 - To": "Settimana 1 - Al",
  "Week 2": "Settimana 2",
  "Week 2 - From": "Settimana 2 - Dal",
  "Week 2 - To": "Settimana 2 - Al",
  "Week Starts": "Inizio settimana",
  "Week of": "Settimana del",
  "Weekly Prep Agent": "Agente di preparazione settimanale",
  "Weekly prep is ready!": "La preparazione settimanale è pronta!",
  "Welcome": "Benvenuto/a",
  "What does CCSS.MATH.4.NF say?": "Cosa dice CCSS.MATH.4.NF?",
  "Will save:": "Verrà salvato:",
  "Working on:": "In lavorazione:",
  "Worksheet": "Scheda di esercizi",
  "Worksheets": "Schede di esercizi",
  "Write the learning objectives...": "Scrivi gli obiettivi di apprendimento...",
  "You need an active subscription": "Hai bisogno di un abbonamento attivo",
  "You need an active subscription to use the AI assistant": "Hai bisogno di un abbonamento attivo per usare l'assistente IA",
  "Your Request": "La tua richiesta",
  "Your digital classroom": "La tua classe digitale",
  "Your saved lesson plans for easy access": "I tuoi piani di lezione salvati a portata di mano",
  "assignments": "compiti",
  "classes scheduled": "lezioni programmate",
  "days": "giorni",
  "days of activities": "giorni di attività",
  "en-US": "it-IT",
  "graded": "corretti",
  "of total": "del totale",
  "points": "punti",
  "questions": "domande",
  "ready": "pronto",
  "students": "studenti",
  "submissions": "consegne",
  "submissions pending": "consegne in sospeso",
  "used": "usato",
  "📅 Calendar file downloaded. Open it to add to Google Calendar, Outlook, or Apple Calendar.": "📅 File del calendario scaricato. Aprilo per aggiungerlo a Google Calendar, Outlook o Apple Calendar.",
  "📅 Schedule (Optional)": "📅 Orario (facoltativo)",
  "📅 Weekly Plan (2 Weeks)": "📅 Piano settimanale (2 settimane)",
  "📗 Week 2": "📗 Settimana 2",
  "📘 Week 1": "📘 Settimana 1",
  "🗣️ Conversational English": "🗣️ Inglese conversazionale",
  "🗣️ Conversational English Plan Details": "🗣️ Dettagli del piano di inglese conversazionale"
};
